import { formatPlainDate } from "@sa-nu/shared-utils/date";
import { formatCurrency } from "@sa-nu/shared-utils/price";

import type { FragmentType } from "../../../__generated__/gql";
import { graphql, useFragment } from "../../../__generated__/gql";

const Fragment = graphql(`
  fragment ChangeOrCancelEstimatedChargeFragment on EstimatedChargeOfAccommodationReservation {
    totalAmountOfFee
    items {
      label
      chargeType
      night
      amountOfFee
    }
  }
`);

export function ChangeOrCancelFee({
  estimationData,
}: {
  estimationData: FragmentType<typeof Fragment>;
}) {
  const estimation = useFragment(Fragment, estimationData);
  const items = estimation.items;
  const group: { [key: string]: (typeof items)[number][] } = {};

  for (const item of items) {
    if (group[item.label]) {
      group[item.label]!.push(item);
    } else {
      group[item.label] = [item];
    }
  }

  return (
    <div className="flex flex-col gap-[16px]">
      {Object.entries(group).map(([name, items]) => (
        <div key={name}>
          <div className="text-[12px] font-bold">{name}</div>
          {
            <div>
              {items.map((item, i) => (
                <div
                  key={i}
                  className="font-roboto flex h-[60px] items-center justify-between border-b-[0.5px] border-b-[#a8a9aa] text-[16px]"
                >
                  <div>
                    {item.night &&
                      formatPlainDate(item.night, {
                        withDayOfWeek: true,
                      })}
                  </div>
                  <div className="font-light">
                    {item.chargeType === "Fee"
                      ? formatCurrency(item.amountOfFee!)
                      : "(1泊を消化)"}
                  </div>
                </div>
              ))}
            </div>
          }
        </div>
      ))}
      <div className="font-roboto flex h-[60px] items-center justify-between text-[14px]">
        <div>合計</div>
        <div className="text-[20px] font-light">
          {formatCurrency(estimation.totalAmountOfFee)}
        </div>
      </div>
    </div>
  );
}
